import React from "react";

import { useTranslation } from "react-i18next";

import { Image, Title, Wrapper } from "./styled";

const EMPTY_IMAGE = require("../../../assets/img/empty-documents.png");

interface EmptySectionProp {
  title?: string;
}

export const EmptySection = ({ title }: EmptySectionProp) => {
  const { t: translate } = useTranslation();

  return (
    <Wrapper>
      <Image src={EMPTY_IMAGE} alt="empty-section-image" />
      <Title>{title ?? translate("noItems")}</Title>
    </Wrapper>
  );
};
